import React from 'react';
import { currencyMask } from '../utils/masks';

interface CurrencyInputProps {
  name: string;
  placeholder?: string;
  className?: string;
  defaultValue?: number;
  disabled?: boolean;
  register: any;
  setValue: (name: string, value: number) => void;
  onChange?: (value: number) => void;
  label?: string;
  error?: string;
  trigger: (name: string) => void;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  name,
  placeholder = "Valor",
  className = "uk-input uk-form-small",
  defaultValue,
  disabled = false,
  register,
  setValue,
  onChange,
  label,
  error,
  trigger
}) => {
  const parseCurrencyValue = (rawValue: string): number => {
    const sanitized = (rawValue || '').replace(/[^\d.,-]/g, '').trim();

    if (!sanitized) {
      return 0;
    }

    const lastComma = sanitized.lastIndexOf(',');
    const lastDot = sanitized.lastIndexOf('.');

    // If both separators exist, the last one is treated as decimal separator.
    if (lastComma !== -1 && lastDot !== -1) {
      if (lastComma > lastDot) {
        const normalized = sanitized.replace(/\./g, '').replace(',', '.');
        return parseFloat(normalized) || 0;
      }

      const normalized = sanitized.replace(/,/g, '');
      return parseFloat(normalized) || 0;
    }

    if (lastComma !== -1) {
      const parts = sanitized.split(',');
      const decimalDigits = parts[parts.length - 1]?.length ?? 0;

      if (decimalDigits > 0 && decimalDigits <= 2) {
        const normalized = sanitized.replace(/\./g, '').replace(',', '.');
        return parseFloat(normalized) || 0;
      }

      const normalized = sanitized.replace(/,/g, '');
      return parseFloat(normalized) || 0;
    }

    if (lastDot !== -1) {
      const parts = sanitized.split('.');
      const decimalDigits = parts[parts.length - 1]?.length ?? 0;

      if (decimalDigits > 0 && decimalDigits <= 2) {
        return parseFloat(sanitized) || 0;
      }

      const normalized = sanitized.replace(/\./g, '');
      return parseFloat(normalized) || 0;
    }

    return parseFloat(sanitized) || 0;
  };

  return (
    <>
      {label && (
        <label className="uk-form-label" htmlFor={name}>
          {label}
        </label>
      )}
      <input type="hidden" name={name} defaultValue={defaultValue} ref={register} />
      <input
        type="text"
        id={name}
        placeholder={placeholder}
        className={className}
        defaultValue={currencyMask(defaultValue)}
        {...register(name)}
        onFocus={(e) => {
          const parsedValue = parseCurrencyValue(e.target.value);
          e.target.value = parsedValue ? String(parsedValue) : '';
          setTimeout(() => {
            e.target.select();
          }, 200);
        }}
        onBlur={(e) => {
          if (e.target.value != '') {
            const numValue = parseCurrencyValue(e.target.value);
            setValue(name, numValue);
            onChange?.(numValue);  // Call the callback
            trigger(name);  // Trigger validation
            e.target.value = currencyMask(numValue);
          }
        }}
        disabled={disabled}
        autoComplete={"off"}
      />
      {error && <small className="uk-text-danger">{error}</small>}
    </>
  );
};

export default CurrencyInput;
